module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-800.9793c85e.svg";